module.exports = __webpack_public_path__ + "img/trophy-self.a3f23724.png";